import "./UiSettingsEditor.0.css";
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import ColsEditor from "../Field/comps/ColsEditor";
const __script_base__ = {
  components: {
    ColsEditor
  },
  mixins: [vueComponentMixin],
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      autoEditor: null
    };
  },
  computed: {
    dataStub() {
      var _this$autoEditor;
      return (_this$autoEditor = this.autoEditor) === null || _this$autoEditor === void 0 ? void 0 : _this$autoEditor.dataStub;
    }
  },
  watch: {
    value: {
      handler() {
        this.syncAutoEditor();
      },
      immediate: true
    }
  },
  methods: {
    syncAutoEditor() {
      // 获取当前激活的 w-form-auto-editor 实例
      // 这个不能放到 computed 里面
      const autoEditor = this.designer.renderer.getRefByPath(this.designer.compPath);
      if (autoEditor !== this.autoEditor) this.autoEditor = autoEditor;
    },
    commit(key, value) {
      const ans = {
        ...this.editValue,
        [key]: value
      };
      if (typeof value === 'undefined') delete ans[key];
      this.editValue = ans;
    },
    eject() {
      /** @type {{ designer: UICore.Designer.Designer }} */
      const {
        designer
      } = this;
      // FIXME: 有点尴尬，这个表单失去焦点的时候会 commit props，导致一些奇怪的问题
      designer.$refs.editZone.$el.focus();
      setTimeout(() => {
        designer.replaceCompWith(designer.compPath, {
          ...designer.activeComp,
          ...this.autoEditor.currentLayout
        });
      }, 200);
    },
    toggleArrayCols() {
      if (this.editValue.cols) {
        this.commit('cols', undefined);
        return;
      }
      const cols = this.dataStub.arrItems.fields.map(f => ({
        id: f.id
      }));
      this.commit('cols', cols);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dataStub ? _c('div', {
    staticClass: "uiSettingsEditor"
  }, [false ? _c('div', [_c('button', {
    staticClass: "uc-button uc-button-primary",
    staticStyle: {
      "display": "block",
      "margin-bottom": "1em"
    },
    on: {
      "click": _vm.eject
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 转换为表单\n    ")])]) : _vm._e(), _vm._v(" "), _vm.dataStub.type === 'array' ? _c('div', [_c('p', [_c('label', [_c('input', {
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.editValue.hideNumber
    },
    on: {
      "change": function ($event) {
        return _vm.commit('hideNumber', $event.target.checked);
      }
    }
  }), _vm._v("\n        隐藏序号列\n      ")])]), _vm._v(" "), _vm.dataStub.arrItems.type === 'object' ? _c('p', [_c('label', [_c('input', {
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !!_vm.editValue.cols
    },
    on: {
      "change": _vm.toggleArrayCols
    }
  }), _vm._v("\n        自定义表格列\n      ")])]) : _vm._e(), _vm._v(" "), !!_vm.editValue.cols ? _c('cols-editor', {
    attrs: {
      "value": _vm.editValue.cols,
      "fields": _vm.dataStub.arrItems.fields
    },
    on: {
      "change": function ($event) {
        return _vm.commit('cols', $event);
      }
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/FormAutoEditor/UiSettingsEditor.vue",
  "_scopeId": "data-v-97b189dc"
}, typeof __script__ === 'function' ? __script__.options : __script__);